import Modal from "../../components/Modal/Modal";
import React, { useState, useMemo } from "react";
import { useApp } from "../../contexts";
import styled from "styled-components";
import { validatePassword, encryptClientPassword } from "../../utils/helper";
import { IconOpenEye } from "../../components/Icons/IconOpenEye";
import { IconCloseEye } from "../../components/Icons/IconCloseEye";
import { useNavigate } from "react-router-dom";
import { IconAIA } from "../Icons/IconSuzuverse";
import LoginAppleButton from "./button/LoginAppleButton";
import LoginFacebookButton from "./button/LoginFacebookButton";
import LoginGoogleButton from "./button/LoginGoogleButton";
import { APP_CONNECT_TYPE } from "../../constants";
import { ssoUpdatePassword } from "../../services/app";

const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ModalUnlinkSocialResetPassword = ({ value, ...props }) => {
  const { T: t } = useApp();
  const navigate = useNavigate();
  const [showPassword, $showPassword] = useState(false);
  const [showConfirmPassword, $showConfirmPassword] = useState(false);
  const {
    handleClickClose,
    onFinishVerify,
    handleLinkOther,
    handleError,
    method,
  } = props;

  const [step] = useState(1);

  const [state, setState] = useState({
    password: "",
    confirmPassword: "",
  });
  const ERROR_DEFAULT = {
    password: "",
    confirmPassword: "",
  };
  const [error, $error] = useState(ERROR_DEFAULT);

  const goToSetPass = () => {
    navigate(`/change-password`);
  };
  const handleLinkAccountSuccess = (e, provider) => {
    handleLinkOther(e, provider);
    onFinishVerify(true);
  };
  const triggerShowPassword = () => {
    $showPassword(!showPassword);
  };

  const triggerShowConfirmPassword = () => {
    $showConfirmPassword(!showConfirmPassword);
  };

  const changeInput = (e, field) => {
    setState((preVal) => {
      const finalData = { ...preVal };
      finalData[field] = e.target.value;
      return finalData;
    });
  };
  const createPassword = async (e) => {
    e.preventDefault();
    if (!validatePassword(state.password)) {
      $error({
        ...error,
        password: t(
          "The password must contain 6 pure letters or is a combination of letters and numbers"
        ),
      });
      return;
    }
    if (state.confirmPassword !== state.password) {
      $error({
        ...error,
        confirmPassword: t("Confirm new password not match."),
      });
      return;
    }
    $error(ERROR_DEFAULT);
    try {
      const res = await ssoUpdatePassword({
        new_password: encryptClientPassword(state.password),
      });
      onFinishVerify(true);
    } catch (err) {
      console.log(err);
    }
  };
  const methodText = useMemo(() => {
    if (method === APP_CONNECT_TYPE.google) {
      return "Google";
    }
    if (method === APP_CONNECT_TYPE.facebook) {
      return "Facebook";
    }
    if (method === APP_CONNECT_TYPE.apple) {
      return "Apple";
    }
  }, [method]);
  return (
    <Modal onClose={handleClickClose}>
      <Modal.ModalBg2 onClose={handleClickClose} />
      <Modal.Container2
        width="500px"
        className={"!bg-suzu-gray-1"}
        onClose={handleClickClose}
      >
        <ContentWaper>
          {step === 1 && (
            <div className={`max-w-full relative transition ease-in-out`}>
              <div className="pb-2 lg:pb-[12px]">
                <p className="text-xl lg:text-2xl text-center text-aia-red font-manrope font-bold h-[31px] whitespace-nowrap">
                  {t("title.header_alternative_signin_method")}
                </p>
              </div>
              <div className="pb-2 lg:pb-[12px] mt-[15px] mb-[20px]">
                <p className="text-base text-center font-[400]">
                  {t(
                    "Currently, {method} is your only way to log in. Before disconnecting, please choose another way to sign in next time"
                  ).replace("{method}", methodText)}
                </p>
              </div>
              <div
                className="max-w-[290px] m-auto mb-[12px] flex items-center gap-[10px] lg:gap-[15px] rounded-[8px] px-[24px] py-[6px] border border-solid border-[#00000026] cursor-pointer"
                onClick={() => goToSetPass()}
              >
                <IconAIA className="w-[20px]" />
                <span className="text-black text-[14px]">
                  {t("title.create_password")}
                </span>
              </div>
              <div className="max-w-[290px] m-auto flex  mb-[12px] items-center gap-[10px] lg:gap-[15px] rounded-[8px] px-[20px] py-[1px] border border-solid border-[#00000026] cursor-pointer">
                <LoginGoogleButton
                  t={t}
                  isModal={true}
                  state={state.googleId}
                  onSucess={(e) =>
                    handleLinkAccountSuccess(e, APP_CONNECT_TYPE.google)
                  }
                  onError={(e) => handleError(e)}
                />
              </div>
              <div className="max-w-[290px] m-auto flex  mb-[12px] items-center gap-[10px] lg:gap-[15px] rounded-[8px] px-[20px] py-[1px] border border-solid border-[#00000026] cursor-pointer">
                <LoginFacebookButton
                  t={t}
                  isModal={true}
                  state={state.facebookId}
                  onSucess={(e) =>
                    handleLinkAccountSuccess(e, APP_CONNECT_TYPE.facebook)
                  }
                  onError={(e) => handleError(e)}
                />
              </div>
              <div className="max-w-[290px] m-auto flex  mb-[12px] items-center gap-[10px] lg:gap-[15px] rounded-[8px] px-[20px] py-[1px] border border-solid border-[#00000026] cursor-pointer">
                <LoginAppleButton
                  t={t}
                  isModal={true}
                  state={state.appleId}
                  onSucess={(e) =>
                    handleLinkAccountSuccess(e, APP_CONNECT_TYPE.apple)
                  }
                  onError={(e) => handleError(e)}
                />
              </div>
            </div>
          )}

          {step === 2 && (
            <div className={`relative transition ease-in-out`}>
              <div className="pb-[26px] lg:pb-[43px]">
                <p className="text-2xl text-center text-aia-red font-bold h-[31px]">
                  {t("title.create_password")}
                </p>
              </div>

              <div className="flex items-center justify-center lg:justify-start max-w-full  mx-auto lg:w-full mb-[25px] lg:mb-[30px] flex-col lg:flex-row">
                <label
                  htmlFor="form_new_password"
                  className="text-black w-full lg:w-[197px] lg:flex-none block pb-1 lg:pb-0"
                >
                  {t("New Password")}
                </label>
                <div className="w-full">
                  <div className="p-[1px] rounded-[10px] relative max-w-full border border-solid">
                    <input
                      id="form_new_password"
                      type={showPassword ? "text" : "password"}
                      className="h-[52px] max-w-full w-full  pl-5 pr-32 py-3 bg-white rounded-[8px] text-black input-gradient appearance-none"
                      placeholder={t("Confirm New Password")}
                      value={state.password}
                      minLength={6}
                      maxLength={6}
                      onChange={(e) => changeInput(e, "password")}
                    />
                    <div className="bg-mark"></div>
                    <div
                      className={`w-6 h-6 flex justify-center ${
                        showPassword ? "items-center" : "items-end"
                      } absolute right-4 top-3.5 z-10 cursor-pointer`}
                      onClick={() => triggerShowPassword()}
                    >
                      {showPassword && <IconOpenEye />}
                      {!showPassword && <IconCloseEye />}
                    </div>
                  </div>
                  {error.password && (
                    <p className=" text-suzu-error text-sm">{error.password}</p>
                  )}
                </div>
              </div>
              <div className="flex lg:items-center justify-center lg:justify-start max-w-full  mx-auto lg:w-full mb-[25px] lg:mb-[30px] flex-col lg:flex-row">
                <label
                  htmlFor="form_confirm_password"
                  className="text-black w-full lg:w-[197px] lg:flex-none block pb-1 lg:pb-0"
                >
                  {t("Enter new password")}
                </label>
                <div className="w-full">
                  <div className="p-[1px] rounded-[10px] relative max-w-full border border-solid ">
                    <input
                      id="form_confirm_password"
                      type={showConfirmPassword ? "text" : "password"}
                      className="h-[52px] max-w-full w-full pl-5 pr-32 py-3 bg-white rounded-[8px] text-black input-gradient appearance-none"
                      placeholder={t("Enter new password again")}
                      value={state.confirmPassword}
                      minLength={6}
                      maxLength={6}
                      onChange={(e) => changeInput(e, "confirmPassword")}
                    />
                    <div className="bg-mark"></div>
                    <div
                      className={`w-6 h-6 flex justify-center ${
                        showPassword ? "items-center" : "items-end"
                      } absolute right-4 top-3.5 z-10 cursor-pointer`}
                      onClick={() => triggerShowConfirmPassword()}
                    >
                      {showConfirmPassword && <IconOpenEye />}
                      {!showConfirmPassword && <IconCloseEye />}
                    </div>
                  </div>
                  {error.confirmPassword && (
                    <p className="text-suzu-error text-sm">
                      {error.confirmPassword}
                    </p>
                  )}
                </div>
              </div>

              <div className="flex justify-center items-center pt-0 lg:pt-12 gap-[15px] flex-col-reverse sm:flex-row lg:border-t lg:border-solid lg:border-black/[0.1]">
                <button
                  className="w-full sm:w-40 h-[52px] px-5 py-4 bg-white text-black border border-solid border-black text-center rounded-[15px]"
                  onClick={handleClickClose}
                >
                  {t("Cancel")}
                </button>
                <button
                  className="w-full sm:w-40 h-[52px] px-5 py-4 bg-black text-white text-center rounded-[15px]"
                  onClick={(e) => createPassword(e)}
                >
                  {t("Create")}
                </button>
              </div>
            </div>
          )}
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  );
};
